module.exports = __webpack_public_path__ + "assets/images/invisible-asia-logo.svg?v=c014d568";